import { Component } from '@angular/core';
import { CXoneAuth } from '@nice-devone/auth-sdk';
import { LoggerService } from 'src/app/core/services/logger.service';
import { LoginService } from 'src/app/core/services/login.service';
import { NiceSdkAuthenticationService } from 'src/app/data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { SdkAcdAgent } from '../../data/CXOne/sdk-acd/sdk-acd.service';
import { environment } from 'src/environments/environment';
import { DynamicsCorretora } from 'src/app/data/Dynamics/dynamics-corretora.service';
import { CXoneAcdClient, CXoneVoiceContact } from '@nice-devone/acd-sdk';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { CreateTicketCorretora } from 'src/app/shared/models/corretora/createTicketCorretora';

const tableName = 'incident';
const customerTableName = 'contact';

@Component({
  selector: 'app-corretora',
  standalone: true,
  imports: [],
  templateUrl: './corretora.component.html',
  styleUrl: './corretora.component.css',
})
export class CorretoraComponent {
  isTemplateReady: boolean = false;
  cxoneAuth: CXoneAuth;

  constructor(
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private eventHandler: EventHandlerService,
    private logger: LoggerService,
    private dynamics: DynamicsCorretora,
    private loginService: LoginService,
    private sdkAcdAgent: SdkAcdAgent,
  ) {
    this.cxoneAuth = CXoneAuth.instance;
  }

  async ngOnInit() {
    this.logger.info('CORRETORA - inicializado');
    const centralId = localStorage.getItem('centralId') || 'corretora';
    const authServiceType = localStorage.getItem('authServiceType') || 'nice';
    const authMode = localStorage.getItem('display_mode') || 'popup';

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );
      if (isAuthenticated) {
        this.logger.info('Corretora - Usuario autenticado');
        await this.niceSdkAuthService.launchAgent();
        await this.sdkAcdAgent.initialize();
        await this.dynamics.initialize(environment.cif_versao2_corretora);
        //this.logger.flushLogInfo();

        CXoneAcdClient.instance.contactManager.voiceContactUpdateEvent.subscribe(
          async (voiceContact: CXoneVoiceContact) => {
            const status = voiceContact.status || '';
            const contactId = voiceContact.contactID || '';
            const contatoEvento = { id: contactId, status: status };
            let eventoProcessado = this.eventHandler.isProcessed(contatoEvento);

            this.logger.info(
              `CORRETORA (ACD) - Voice Contact status: ${status} | evento: `,
              voiceContact,
            );

            if (
              status === VoiceContactStatusAgent.ACTIVE &&
              !eventoProcessado
            ) {
              this.eventHandler.add(contatoEvento);
              await this.activeVoiceEvent(voiceContact);
            }

            if (status === VoiceContactStatusAgent.DISCONNECTED) {
              this.eventHandler.remove(contatoEvento);
              const sessionId = localStorage.getItem(voiceContact.contactID);

              localStorage.removeItem(voiceContact.contactID);
              localStorage.removeItem(`${sessionId}`);
              localStorage.removeItem('sessionBeingAttended');
            }
          },
        );
      }
    } catch (error) {
      this.logger.error('Corretora - Erro ao autenticar usuario: ', error);
    }
  }

  private async activeVoiceEvent(
    voiceContact: CXoneVoiceContact,
  ): Promise<void> {
    try {
      //this.logger.flushLogInfo();
      const attachdataValues = this.sdkAcdAgent.deserializeScreenPopUrl(
        voiceContact.screenPopUrl,
      );
      let direction = '';
      let ani = voiceContact.ani;

      if (voiceContact.isInbound == true) {
        direction = 'Entrada';

        if(ani.startsWith('+55')) {
          ani = ani.substring(3);
        } else  {
          ani = ani.substring(5);
        }

      } else {
        direction = 'Saída';
        ani = voiceContact.dnis.substring(6);
      }
      //this.logger.flushLogInfo();

      let customerId = await this.dynamics.cifSearchAndOpenRecords(
        customerTableName,
        ani,
      );

      if (Object.keys(attachdataValues).length > 0) {
        const u_tag = attachdataValues.u_json.U_TAG;
        var msft_esteira = '';

        switch (voiceContact.skill) {
          case '23053356': //BOVESPA
            msft_esteira = environment.esteiras_corretora.bovespa;
            break;
          case '23053357': //BMF
            msft_esteira = environment.esteiras_corretora.BMF;
            break;
          case '23053358': //BTC
            msft_esteira = environment.esteiras_corretora.BTC;
            break;
          case '23053359': //Cadastro
            msft_esteira = environment.esteiras_corretora.cadastro;
            break;
          case '23053360': //Custódia e Margem
            msft_esteira = environment.esteiras_corretora.custodia_margem;
            break;
          case '23053361': //Financeiro
            msft_esteira = environment.esteiras_corretora.financeiro;
            break;
          default: //Fora do Dynamics
            msft_esteira = environment.esteiras_corretora.esteira_default;
        }
      } else {
        switch (voiceContact.skill) {
          case '23121863': //BOVESPA
            msft_esteira = environment.esteiras_corretora.bovespa;
            break;
          case '23121862': //BMF
            msft_esteira = environment.esteiras_corretora.BMF;
            break;
          case '23121864': //BTC
            msft_esteira = environment.esteiras_corretora.BTC;
            break;
          case '23121865': //Cadastro
            msft_esteira = environment.esteiras_corretora.cadastro;
            break;
          case '23121866': //Custódia e Margem
            msft_esteira = environment.esteiras_corretora.custodia_margem;
            break;
          case '23121867': //Financeiro
            msft_esteira = environment.esteiras_corretora.financeiro;
            break;
          default: //Fora do Dynamics
            msft_esteira = environment.esteiras_corretora.esteira_default;
        }
      }

      var data: CreateTicketCorretora = {
        title: `Abertura Automática Integração Agent - ${direction}`,
        'msft_Esteira@odata.bind': `${msft_esteira}`,
        'customerid_contact@odata.bind': `/contacts(${customerId})`,
        caseorigincode: 1,
        'msft_Classificacao@odata.bind': `${environment.esteiras_corretora.classificacao}`,
        'msft_AssuntodaOcorrencia@odata.bind': `${environment.esteiras_corretora.assunto}`,
        description: `ContactId: ${voiceContact.contactID}`,
      };

      this.logger.info('CORRETORA - AttachData: ', data);

      let result = await this.dynamics.cifCreateIncident(tableName, data);

      if (!result || !result.id_interacao || !result.id_ticket) {
        this.logger.error('CORRETORA - Erro ao criar ticket: ', result);
        return;
      }

      var input_sessao_atendimento = {
        templateName: 'cxa_embedded_poc_session_2',
        templateParameters: {
          entityId: result.id_interacao,
          entityName: 'incident',
        },
      };

      const sessionId = await this.dynamics.cifCreateSession(
        input_sessao_atendimento,
      );

      this.logger.info(
        `CORRETORA - Ticket criado com sucesso: ID Interação: ${result.id_interacao}, ID Ticket: ${result.id_ticket}`,
      );

      localStorage.setItem(voiceContact.contactID, sessionId);
      localStorage.setItem(sessionId, voiceContact.contactID);
      localStorage.setItem('sessionBeingAttended', sessionId);
    } catch (error) {
      this.logger.error(
        'CORRETORA - Erro ao processar evento de contato de voz: ',
        error,
      );
    }
  }
}
